import React from 'react';
import PropTypes from 'prop-types';
import {Button, Item} from 'semantic-ui-react';
import {EmptyFunc, isFunction} from "utils/DBUtils";
import {FormattedMessage} from "react-intl";

const getItem = (list, index) => {
    if (Array.isArray(list) && index < list.length) {
        return list[index];
    }
    return null;
};

const ItemInfoGroup = (props) => (
    <Item.Group className={"item-info-group" + (props.className ? ` ${props.className}` : "")}>
        {!Array.isArray(props.itemDetails) ? "" : props.itemDetails.map((details, index) => (
            <Item className={`anim-spawn${props.animationType} animTime-slow`}>
                <Item.Content>
                    <Item.Header className="item-info-header"
                                 onClick={isFunction(props.onHeaderClick) ? () => props.onHeaderClick(getItem(props.items, index)) : EmptyFunc}>
                        {details.header}
                    </Item.Header>
                    <Item.Description>
                        {details.description}
                    </Item.Description>
                    {isFunction(props.onRemoveClick) ? (
                        <Button onClick={(event) => props.onRemoveClick(getItem(props.items, index))}>
                            <FormattedMessage id='remove'/>
                        </Button>
                    ) : ""}
                </Item.Content>
            </Item>
        ))}
    </Item.Group>
);

ItemInfoGroup.propTypes = {
    className: PropTypes.string,
    onRemoveClick: PropTypes.func,
    onHeaderClick: PropTypes.func,
    items: PropTypes.arrayOf(PropTypes.shape({
        header: PropTypes.string,
        description: PropTypes.string,
    })),
    itemDetails: PropTypes.arrayOf(PropTypes.any),
    animationType: PropTypes.oneOf(["Success", "Error"])
};

ItemInfoGroup.defaultProps = {
    items: [{
        header: "Placeholder Header",
        description: "Placeholder Description"
    }],
    itemDetails: [{
        id: "Placeholder Item"
    }],
    animationType: "Success"
};

export default ItemInfoGroup;


// WEBPACK FOOTER //
// ./public/components/common/ItemInfoGroup.jsx